'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';

const BASE =
  'w-full bg-surface-3 border border-border-subtle rounded-sm px-3 py-2 text-text-primary text-sm placeholder:text-text-tertiary focus:border-accent focus:outline-none transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...rest }, ref) => {
    return <input ref={ref} type={type} className={cn(BASE, className)} {...rest} />;
  }
);
Input.displayName = 'DsInput';
